/**
 * Returns the CSS class for an order status badge.
 *
 * The human-readable label is now delivered by the backend as
 * `order.order_status_name`, localized via the `8i9_order_status` table.
 * Templates should render that field directly and use this helper only
 * for styling.
 */
export function statusOrderClass(orderStatus: number): string {
  if (
    orderStatus === 1 ||
    orderStatus === 12 ||
    orderStatus === 9 ||
    orderStatus === 0
  ) {
    return 'wait-class'
  }

  if (orderStatus === 4) {
    return 'wait-class'
  }

  if (orderStatus === 2) {
    return 'preparation-class'
  }

  if (orderStatus === 5) {
    return 'approve-class'
  }

  if (orderStatus === 3) {
    return 'ready-class'
  }

  if (orderStatus === 6) {
    return 'delivery-class'
  }

  return ''
}

/**
 * @deprecated Use `statusOrderClass(id)` for the class and render
 * `order.order_status_name` from the API for the text.
 * Kept for template back-compat; `text` is always empty now.
 */
export function statusOrder(orderStatus: number) {
  return { text: '', class: statusOrderClass(orderStatus) }
}
